import { SidebarItem } from "../../types/sidebar";

export const SidebarData: SidebarItem[] = [
  {
    name: "dashboard",
    title: "داشبورد",
    path: "/dashboard-page",
    icon: "DashboardIcon",
  },

  {
    name: "grouping",
    title: "گروهبندی",
    icon: "GroupsIcon",
    subNav: [
      {
        name: "departments",
        title: "دپارتمان ها",
        path: "/departments",
        icon: "DepartmentIcon",
      },
      {
        name: "Multiple membership",
        title: "چند عضویتی",
        path: "/user-grouping",
        icon: "UserGroupIcon",
      },
    ],
  },

  {
    name: "users",
    title: "مدیریت کاربران",
    icon: "Users",
    subNav: [
      {
        name: "userManagment",
        title: "ثبت کاربر",
        path: "/add-users",
        icon: "UserAddIcon",
      },
      {
        name: "permission",
        title: "تعریف نقش و مجوزها",
        path: "/access-level",
        icon: "UserRoleIcon",
      },
    ],
  },
  {
    name: "creating-content",
    title: "تولید محتوا",
    icon: "ContentIcon",
    subNav: [
      {
        name: "addArticle",
        title: "ثبت مقاله",
        path: "/add-article",
        icon: "AddingIcon",
      },
      {
        name: "articlesList",
        title: "  لیست مقالات",
        path: "/article-list",
        icon: "ListIcon",
      },
      {
        name: "addNews",
        title: "ثبت اخبار",
        path: "/add-news",
        icon: "AddingIcon",
      },
      {
        name: "newsList",
        title: "لیست اخبار",
        path: "/news-list",
        icon: "ListIcon",
      },
      {
        name: "addProject",
        title: "ثبت پروژه",
        path: "/add-project",
        icon: "AddingIcon",
      },
      {
        name: "projectsList",
        title: "لیست پروژه ها",
        path: "/project-list",
        icon: "ListIcon",
      },
      {
        name: "catalog",
        title: "ثبت کاتالوگ",
        path: "/catalog",
        icon: "AddingIcon",
      },
      {
        name: "catalogList",
        title: "لیست کاتالوگ ها",
        path: "/catalog-list",
        icon: "ListIcon",
      },
    ],
  },
  {
    name: "coopearion",
    title: "همکاری با ما",
    icon: "CooperationIcon",
    subNav: [
      {
        name: "cooperation",
        title: "ثبت آکهی",
        icon: "PaperIcon",
        path: "/cooperation-page",
      },
      {
        name: "coopRequest",
        title: "درخواست های ارسال شده",
        icon: "PaperIcon",
        path: "/cooperation-req",
      },
    ],
  },

  {
    name: "setting",
    title: "تنظیمات",
    icon: "SettingIcon",
    subNav: [
      {
        name: "page_detaile",
        title: "ثبت صفحه جدید",
        path: "/page_detaile",
        icon: "LinkIcon",
      },
      {
        name: "contactUs",
        title: "اطلاعات وب سایت",
        path: "/contact-us",
        icon: "ContactUsIcon",
      },
      {
        name: "sliderManagement",
        title: "مدیریت اسلایدر",
        path: "/slider-management",
        icon: "SliderIcon",
      },
      {
        name: "links",
        title: "ثبت لینک ها",
        path: "/links",
        icon: "LinkIcon",
      },
      {
        name: "faq",
        title: "سوالات متداول",
        icon: "FaqIcon",
        path: "/faq-page",
      },
    ],
  },
];
